/**
 * Le VOCABULAIRE des capacites, tel que le serveur le nomme.
 *
 * ⚠️ CE FICHIER NE PORTE AUCUNE REGLE. Il ne dit pas quel role possede quoi -- cette
 * matrice vit dans `backend/app/core/authz.py`, et elle y vit SEULE. Ici il n'y a que
 * les noms, pour que `cap: CAP.TARIFS_READ` se relise mieux que `cap: 'tarifs:read'`
 * et qu'une faute de frappe devienne une erreur de build plutot qu'une entree de menu
 * silencieusement invisible.
 *
 * La difference n'est pas cosmetique. Une table `role -> capacites` recopiee ici serait
 * une seconde source de verite et derivera : c'est exactement ce que la matrice des
 * droits cote serveur a ete ecrite pour empecher. Une liste de NOMS, elle, ne peut pas
 * mentir sur un droit ; au pire elle nomme une capacite qui n'existe plus, et l'entree
 * correspondante disparait du menu pour tout le monde -- un defaut visible, pas un trou.
 *
 * Les valeurs suivent `backend/app/core/authz.py` au caractere pres.
 */
export const CAP = {
  CLIENTS_READ: 'clients:read',
  CLIENTS_WRITE: 'clients:write',
  CLIENTS_DELETE: 'clients:delete',
  DASHBOARD_READ: 'dashboard:read',
  MONITORING_READ: 'monitoring:read',
  TARIFS_READ: 'tarifs:read',
  TARIFS_WRITE: 'tarifs:write',
  MENUS_READ: 'menus:read',
  MENUS_WRITE: 'menus:write',
  USERS_MANAGE: 'users:manage',
  INTEGRATIONS_MANAGE: 'integrations:manage',
  INSTALL_SIGN: 'install:sign',
  SAV_READ: 'sav:read',
  PILOTAGE: 'monitoring:control',
  BULK_EXECUTE: 'bulk:execute',
  // Deleguee : le gestionnaire ne la porte que si son admin l'ouvre. Le nom
  // suffit ici -- savoir QUI la porte reste l'affaire du serveur.
  CLIENTS_AGREGATEUR: 'clients:agregateur',
};

export default CAP;
